import { decodeInLoop } from '../../../../utils/decodeInLoop';

export function parseUrlCoordinates(rawCoordinates: string): number[][] {
  const decodedCoordinates = decodeInLoop(rawCoordinates);

  try {
    const parsedCoordinates: unknown = JSON.parse(decodedCoordinates);

    if (
      Array.isArray(parsedCoordinates) &&
      parsedCoordinates.length === 2 &&
      parsedCoordinates.every((value) => typeof value === 'number')
    ) {
      return [parsedCoordinates as number[]];
    }

    if (
      Array.isArray(parsedCoordinates) &&
      parsedCoordinates.every(
        (item) =>
          Array.isArray(item) &&
          item.length === 2 &&
          item.every((value) => typeof value === 'number')
      )
    ) {
      return parsedCoordinates as number[][];
    }
  } catch {
    // Fallback to parser that handles comma format (x,y)
  }

  const fallbackCoordinates = decodedCoordinates.split(',').map(Number);

  if (
    fallbackCoordinates.length === 2 &&
    fallbackCoordinates.every((value) => !Number.isNaN(value))
  ) {
    return [fallbackCoordinates];
  }

  return [];
}
